import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from 'react-apollo';
import Select from 'react-select';

import { consumerRootContent } from '../../../../../apps/pro/views/AlbumFolder/AlbumFolders/AlbumFoldersShutterbugHome/graphql';
import { OWNER_STATUS_FILTER_ENUM } from '../../../../../apps/pro/views/AlbumFolder/AlbumFolders/AlbumFoldersShutterbugHome/constants';
import { SORT_DIRECTION } from '../../../../../constants/sort';
import useDebounce from '../../../../../hooks/useDebounce';
import Label from '../../../Label';
import useOpenAlert from '../../../../../hooks/useOpenAlert';
import { getErrorString } from '../../../../../util/normalize-errors';

const propTypes = {
  values: PropTypes.shape({
    hierarchy_item_id: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
};

const ConsumerRootContentSearchSelect = ({ values, handleChange }) => {
  const client = useApolloClient();
  const openAlert = useOpenAlert();
  const [selectedMembershipGroup, setSelectedMembershipGroup] = useState({
    value: '',
    label: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [searchQueryDebounced] = useDebounce(searchQuery, 500);

  const hierarchyGroupSearch = async (query = '') => {
    try {
      const {
        data: { me: user },
      } = await client.query({
        query: consumerRootContent,
        variables: {
          search_query: query,
          owner_status: OWNER_STATUS_FILTER_ENUM.NOT_OWNER,
          include_matched_photos_only: true,
          sort: {
            field: 'CREATED_AT',
            direction: SORT_DIRECTION.DESC,
          },
          limit: 999,
        },
      });

      return (user?.hierarchy_groups?.records ?? [])
        .filter(({ album_membership_group }) => !!album_membership_group)
        .map(({ album_membership_group: albumMembership }) => ({
          label: albumMembership.display_name,
          value: albumMembership.id,
        }));
    } catch (error) {
      openAlert(getErrorString(error));

      return [];
    }
  };

  const getDefaultOptions = async ({ query }) => {
    const defaultOptionsRes = await hierarchyGroupSearch(query);
    setDefaultOptions(defaultOptionsRes);
  };

  useEffect(() => {
    getDefaultOptions({ query: searchQueryDebounced });
  }, [searchQueryDebounced]);

  useEffect(() => {
    if (selectedMembershipGroup) {
      handleChange({
        target: {
          name: 'hierarchy_item_id',
          value: selectedMembershipGroup.value,
        },
      });
    }
  }, [selectedMembershipGroup]);

  useEffect(() => {
    if (!values.hierarchy_item_id) {
      setSelectedMembershipGroup({ id: '', label: '' });
    }
  }, [values.hierarchy_item_id]);

  return (
    <div className="form-group">
      <Label
        id="hierarchy-item-id"
        label="At which event are you experiencing issues?"
      />
      <Select
        inputId="album-ids"
        placeholder="Search by event name..."
        className="z-5"
        value={selectedMembershipGroup?.id}
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? 'No events found with that criteria...'
            : 'Search by event name...'
        }
        onInputChange={input => setSearchQuery(input)}
        options={defaultOptions ?? []}
        loadOptions={searchQueryDebounced}
        getOptionValue={item => item.value}
        onChange={hierarchyGroup => setSelectedMembershipGroup(hierarchyGroup)}
        cacheOptions={false}
      />
    </div>
  );
};

ConsumerRootContentSearchSelect.propTypes = propTypes;

export default ConsumerRootContentSearchSelect;
